import { render, staticRenderFns } from "./HomepageHeroTournament.vue?vue&type=template&id=34dcafc1&scoped=true&"
import script from "./HomepageHeroTournament.vue?vue&type=script&lang=js&"
export * from "./HomepageHeroTournament.vue?vue&type=script&lang=js&"
import style0 from "./HomepageHeroTournament.vue?vue&type=style&index=0&id=34dcafc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dcafc1",
  null
  
)

export default component.exports